/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'door': {
    width: 16,
    height: 16,
    viewBox: '0 0 121.24 151.54',
    data: '<path pid="0" d="M106.08 151.54H22.73a15.17 15.17 0 0 1-15.16-15.15v-22.74h15.16v22.74h83.35V15.15H22.73v22.73H7.57V15.15A15.17 15.17 0 0 1 22.73 0h83.35a15.17 15.17 0 0 1 15.15 15.15v121.24a15.17 15.17 0 0 1-15.15 15.15z"/><path pid="1" d="M58.39 40.1l-10.7 10.73 17.4 17.36H0v15.16h65.02l-17.34 17.38 10.73 10.7L94.06 75.7 58.39 40.1z"/>'
  }
})
